export default __webpack_public_path__ + "static/media/mobile-automated-email.666afbd0.svg";